module.exports = __webpack_public_path__ + "assets/img/year-content-c-bg.f7029d63.png";